const genericTranslations = {
  add: {
    id: "utils.genericTranslations.add",
    description: "'Add' label.",
    defaultMessage: "Add",
  },
  addAttachment: {
    id: "utils.genericTranslations.addAttachment",
    description: "Generic 'add attachment' title.",
    defaultMessage: "Add attachment",
  },
  article: {
    id: "utils.genericTranslations.article",
    description: "'Article' Label",
    defaultMessage: "Article",
  },
  attachments: {
    id: "utils.genericTranslations.attachments",
    description: "Generic 'attachments' title.",
    defaultMessage: "Attachments",
  },
  back: {
    id: "utils.genericTranslations.back",
    description: "Back label.",
    defaultMessage: "Back",
  },
  cancel: {
    id: "utils.genericTranslations.cancel",
    description: "'Cancel' label.",
    defaultMessage: "Cancel",
  },
  category: {
    id: "utils.genericTranslations.category",
    description: "Category label.",
    defaultMessage: "Category",
  },
  close: {
    id: "utils.genericTranslations.close",
    description: "'Close' label.",
    defaultMessage: "Close",
  },
  closeNotification: {
    id: "utils.genericTranslations.closeNotification",
    description: "'Close Notification' label.",
    defaultMessage: "Close notification",
  },
  create: {
    id: "utils.genericTranslations.create",
    description: "Create label",
    defaultMessage: "create",
  },
  delete: {
    id: "utils.genericTranslations.delete",
    description: "'Delete' label.",
    defaultMessage: "Delete",
  },
  deleteArticle: {
    id: "utils.genericTranslations.deleteArticle",
    description: "'Delete article' label.",
    defaultMessage: "Delete article",
  },
  description: {
    id: "utils.genericTranslations.description",
    description: "'Description' label.",
    defaultMessage: "Description",
  },
  edit: {
    id: "utils.genericTranslations.edit",
    description: "'Edit' label.",
    defaultMessage: "Edit",
  },
  error: {
    id: "utils.genericTranslations.errorMessage",
    description: "Error message",
    defaultMessage: "Something went wrong",
  },
  errorFetchingAttachments: {
    id: "utils.genericTranslations.errorFetchingAttachments",
    description: "Generic 'fetch attachments failed' error message.",
    defaultMessage: "Something went wrong while fetching the attachments",
  },
  errorMessage: {
    id: "utils.genericTranslations.errorMessage",
    description: "Error message",
    defaultMessage: "Something went wrong!",
  },
  field: {
    id: "utils.genericTranslations.field",
    description: "Generic 'field' title.",
    defaultMessage: "Field",
  },
  fieldRequired: {
    id: "utils.genericTranslations.fieldRequired",
    description: "Generic 'field required' form validation message.",
    defaultMessage: "This field is required.",
  },
  file: {
    id: "utils.genericTranslations.file",
    description: "'File' label.",
    defaultMessage: "File",
  },
  forgotPassword: {
    id: "utils.genericTranslations.forgotPassword",
    description: "'Forgot password' label.",
    defaultMessage: "Forgot password",
  },
  formFieldSelect: {
    id: "utils.genericTranslations.formFieldSelect",
    description: "Generic 'form field selectbox' title.",
    defaultMessage: "Form fields",
  },
  formFieldsSelectTooltip: {
    id: "utils.genericTranslations.formFieldsSelectTooltip",
    description: "Generic 'form fields selectbox ' tooltip.",
    defaultMessage: "Insert form field",
  },
  formNoName: {
    id: "utils.genericTranslations.formNoName",
    description: "Generic 'form with no name' title.",
    defaultMessage: "Unnamed form",
  },
  formRequiredField: {
    id: "utils.genericTranslations.formRequiredField",
    description: "Generic 'required field' label.",
    defaultMessage: "This field is required",
  },
  formSelect: {
    id: "utils.genericTranslations.formSelect",
    description: "Generic 'forms selectbox' title.",
    defaultMessage: "Forms",
  },
  formSelectTooltip: {
    id: "utils.genericTranslations.formSelectTooltip",
    description: "Generic 'forms selectbox ' tooltip.",
    defaultMessage: "Insert form",
  },
  formSubmitFailed: {
    id: "utils.genericTranslations.formSubmitFailed",
    description: "Generic 'form submit failed' message.",
    defaultMessage:
      "Something went wrong submitting the form. This incident has been reported.",
  },
  formSubmitLabel: {
    id: "utils.genericTranslations.formSubmitLabel",
    description: "Generic 'form submit' label.",
    defaultMessage: "Send",
  },
  from: {
    id: "utils.genericTranslations.from",
    description: "From label",
    defaultMessage: "From",
  },
  group: {
    id: "utils.genericTranslations.group",
    description: "'Group' label.",
    defaultMessage: "Group",
  },
  information: {
    id: "utils.genericTranslations.information",
    description: "Explanation label",
    defaultMessage: "Explanation",
  },
  loadingInProgress: {
    id: "utils.genericTranslations.loadingInProgress",
    description: "'Loading in progress' label.",
    defaultMessage: "Loading...",
  },
  login: {
    id: "utils.genericTranslations.login",
    description: "'Login' label.",
    defaultMessage: "Login",
  },
  name: {
    id: "utils.genericTranslations.name",
    description: "'Name' label.",
    defaultMessage: "Name",
  },
  no: {
    id: "utils.genericTranslations.no",
    description: "No label.",
    defaultMessage: "No",
  },
  yes: {
    id: "utils.genericTranslations.yes",
    description: "Yes label",
    defaultMessage: "Yes",
  },
  nothingFound: {
    id: "utils.genericTranslations.nothingFound",
    description: "nothing found message",
    defaultMessage: "Nothing found!",
  },
  post: {
    id: "utils.genericTranslations.post",
    description: "'Post' label.",
    defaultMessage: "Post",
  },
  read: {
    id: "utils.genericTranslations.read",
    description: "'Read' label.",
    defaultMessage: "Read",
  },
  required: {
    id: "utils.genericTranslations.required",
    description: "Generic 'Required' form validation message.",
    defaultMessage: "Required",
  },
  return: {
    id: "utils.genericTranslations.return",
    description: "Generic 'return to' title.",
    defaultMessage: "Return",
  },
  save: {
    id: "utils.genericTranslations.save",
    description: "'Save' label.",
    defaultMessage: "Save",
  },
  title: {
    id: "utils.genericTranslations.title",
    description: "'Application' label.",
    defaultMessage: "Application",
  },
  updatedAt: {
    id: "utils.genericTranslations.updatedAt",
    description: "'Updated at' label",
    defaultMessage: "Updated at",
  },
  updatedBy: {
    id: "utils.genericTranslations.updatedBy",
    description: "'Updated by' label",
    defaultMessage: "Updated by",
  },
  saveAndSend: {
    id: "utils.genericTranslations.saveAndSend",
    description: "'Save and Send' label.",
    defaultMessage: "Save and Send",
  },
  search: {
    id: "utils.genericTranslations.search",
    description: "Search label",
    defaultMessage: "Search...",
  },
  date: {
    id: "utils.genericTranslations.date",
    description: "Date label",
    defaultMessage: "Date",
  },
};

export default genericTranslations;
